import { Box, IconWithTextLockup } from '@deckee/deck-hand';
import React, { FC } from 'react';
import styled from 'styled-components';
import { IconWithTextLockupProps } from '../../../../lockups/IconWithTextLockup/IconWithTextLockup';
import StyledNavListItem from '../StyledNavListItem/StyledNavListItem';

const IconWithTextLockupListItem = styled(IconWithTextLockup).attrs({
  // py: 2,
  // px: 2, // We need the px for when there is a border, it isn't touching the icons
})`
  overflow: hidden;
  // Last child has no margin bottom
  &:last-child {
    margin-bottom: 0;
  }
`;
type SafetyGearFilterBlockProps = IconWithTextLockupProps & { error?: boolean };

const SafetyGearFilterBlock: FC<SafetyGearFilterBlockProps> = ({
  error,
  onClick,
  children,
  ...rest
}) => (
  <StyledNavListItem chevron error={error} onClick={onClick}>
    <IconWithTextLockupListItem
      descriptionColor="black"
      emphasis="description"
      useEllipsis
      {...rest}
    >
      {children && (
        <Box fontSize={1} color="darkergrey">
          {children}
        </Box>
      )}
    </IconWithTextLockupListItem>
  </StyledNavListItem>
);

SafetyGearFilterBlock.defaultProps = {
  error: false,
};

export default SafetyGearFilterBlock;
